export default __webpack_public_path__ + "static/media/sj.af9b74eb.svg";